import React, { memo, useMemo } from 'react';
import { Icon, Text, createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'SummaryBox');

const SummaryBox = memo(({ icon, text, iconColor, secondaryColor, text2, param }) => {
    const theme = useTheme();
    const { t } = useWeb5Context();
    const classes = useStyles();
    const getFinalLiteral = useMemo(() => {
        let literal;
        let secondParam;
        if (text2) {
            secondParam = t(text2, [param]);
            literal = t(text, [secondParam]);
            return literal;
        }
        return t(text);
    }, [param, t, text, text2]);
    return (
        <div className={classes.summaryBox}>
            {icon && (
                <div className={classes.icon}>
                    <Icon
                        color={iconColor}
                        size="big"
                        name={icon}
                        overrides={{ icon: { secondaryColor: secondaryColor } }}
                    />
                </div>
            )}
            <div>
                <Text type="subtitle1" color={theme.colors.textLight.secondary}>
                    {getFinalLiteral}
                </Text>
            </div>
        </div>
    );
});

export default SummaryBox;
